import { connect } from "react-redux";
import OvFilterPanel from "./OvFilterPanel";
import { setInputValue } from "./actions/overviewParams";
import { 
  setExcludeZeroComputeAction, 
  setMinStorageCostEnabledAction, 
  setMinStorageCostAction 
} from "./actions/overviewParams";

import { openDatePicker, closeDatePicker } from "./actions/datepicker";
import { utcMomentToLocalDate } from "./helpers/dates";

import { PERIOD_MAP, GRANULARITY_MAP } from "./actions/usage";

const itemWithKeyAsValue = (obj, key) => Object.assign({}, obj, { value: key });

const generateMenuItems = itemMap => {
  return Object.keys(itemMap)
    .map(k => itemWithKeyAsValue(itemMap[k], k))
    .sort(function (a, b) {
      if (a.order < b.order) {
        return -1;
      }
      if (a.order > b.order) {
        return 1;
      }
      return 0;
    });
};

const mapStateToProps = (state, ownProps) => {
  const { granularity } = state.overview.filters;
  return {
    overviewDatePickerVisible: state.ui.overviewDatePickerVisible,
    filterPanelVisible: state.ui.overviewFiltersVisible,
    periodMenuItems: generateMenuItems(PERIOD_MAP),
    granularityMenuItems: generateMenuItems(GRANULARITY_MAP),
    selectedPeriod: state.overview.filters.period,
    selectedGranularity: itemWithKeyAsValue(
      GRANULARITY_MAP[granularity],
      granularity
    ),

    filterState: state.overview.filters
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openDatePicker: range => {
      const localRange = {
        start: utcMomentToLocalDate(range.start),
        end: utcMomentToLocalDate(range.end)
      };

      dispatch(openDatePicker(localRange));
    },
    closeDatePicker: () => {
      dispatch(closeDatePicker());
    },
    setAutosuggestInputValue: (filterKey, newValue) => {
      dispatch(setInputValue(filterKey, newValue));
    },
    setExcludeZeroCompute: (exclude) => {
      dispatch(setExcludeZeroComputeAction(exclude));
    },
    setMinStorageCostEnabled: (enabled) => {
      dispatch(setMinStorageCostEnabledAction(enabled));
    },
    setMinStorageCost: (cost) => {
      dispatch(setMinStorageCostAction(cost));
    }
  };
};

const OvFilterPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OvFilterPanel);

export default OvFilterPanelContainer;



// WEBPACK FOOTER //
// ./src/OvFilterPanelContainer.js